import React from "react";
import { Link } from "react-router-dom";
import IntlMessages from "../../util/IntlMessages";

const Error404 = () => (
	<div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
		<div className="page-error-content">
			<div className="error-code mb-4 animated zoomInDown">
				<IntlMessages id="errors.404.code" />
			</div>
			<p className="text-center fw-regular title bounceIn animation-delay-10 animated text-hilight">
				<i className="zmdi zmdi-alert-circle" /> <IntlMessages id="errors.404.desc" />
			</p>
			<p className="text-center zoomIn animation-delay-20 animated">
				<Link className="btn btn-primary mt-4 text-hilight" to="/">
					<i className="zmdi zmdi-arrow-left zmdi-hc-fw" /> <IntlMessages id="go.back.main" />
				</Link>
			</p>
		</div>
	</div>
);

export default Error404;
